const keys = {
    "geolocation" :'0f761a30-fe14-11e9-b59f-e53803842572',
    "ipStack": "aaabfcda9f70b5ad40103430753cce85"
}
export default keys;
